module.exports = __webpack_public_path__ + "img/vaulthex.ba0f2c2a.svg";